var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSpareAxleRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_SpareAxleRequest_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 340.2 198.4",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Icon_SpareAxleRequest_svg__st0{fill:#000}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_SpareAxleRequest_svg__Icon_INV"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Icon_SpareAxleRequest_svg__st0",
    d: "M184.5 43.5v7.1h-35.8v-7.1h-22.6v100.4h81.8l.1-100.4h-23.5zm-29.7 75.6h-12.2v-11.6h12.2v11.6zm0-18h-12.2V89.5h12.2v11.6zm0-18h-12.2V71.5h12.2v11.6zm36.4 29.7h-27.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h27.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5zm0-15h-27.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h27.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5zm0-14.7h-27.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h27.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Icon_SpareAxleRequest_svg__st0",
    d: "M152.9 36.8h26.9v8.8h-26.9z"
  }))));
}

export default SvgIconSpareAxleRequest;